// TRACKS
export const SET_TRACKS = "SET_TRACKS";
export const DELETE_TRACKS = "DELETE_TRACKS";
export const RENAME_TRACK = "RENAME_TRACK";
export const LIKE_TRACK = "LIKE_TRACK";
export const UNLIKE_TRACK = "UNLIKE_TRACK";
export const MARK_TRACK_AS_REMOVED = "MARK_TRACK_AS_REMOVED";
export const UNMARK_TRACK_AS_REMOVED = "UNMARK_TRACK_AS_REMOVED";

// ALBUMS
export const SET_ALBUMS = "SET_ALBUMS";
export const DELETE_ALBUM = "DELETE_ALBUM";
export const LIKE_ALBUM = "LIKE_ALBUM";
export const UNLIKE_ALBUM = "UNLIKE_ALBUM";
export const UNMARK_ALBUM_AS_REMOVED = "UNMARK_ALBUM_AS_REMOVED";
export const MARK_ALBUM_AS_REMOVED = "MARK_ALBUM_AS_REMOVED";

// ARTIST
export const SET_PERSONAL_INFO = "SET_PERSONAL_INFO";
export const SET_PERSONAL_SINGLES = "SET_PERSONAL_SINGLES";
export const SET_PERSONAL_ALBUMS = "SET_PERSONAL_ALBUMS";

// ARTISTS
export const SET_ARTISTS = "SET_ARTISTS";
export const LIKE_ARTIST = "LIKE_ARTIST";
export const UNLIKE_ARTIST = "UNLIKE_ARTIST";

// GENRES
export const SET_GENRES = "SET_GENRES";
export const SET_GENRES_YEARS = "SET_GENRES_YEARS";

// DIRECTIONS
export const SET_DIRECTIONS = "SET_DIRECTIONS";

// PLAYER
export const SET_PROGRESS = "SET_PROGRESS";
export const SET_PRELOAD = "SET_PRELOAD";
export const SET_RUNNING = "SET_RUNNING";
export const SET_PAUSED = "SET_PAUSED";
export const SET_PLAYER_PLAYLIST = "SET_PLAYER_PLAYLIST";
export const SET_REPEAT = "SET_REPEAT";
export const SET_SHUFFLE = "SET_SHUFFLE";
export const SET_VOLUME = "SET_VOLUME";

// QUEUE
export const CLEAR_QUEUE = "CLEAR_QUEUE";
export const ADD_TO_QUEUE = "ADD_TO_QUEUE";
export const REMOVE_FROM_QUEUE = "REMOVE_FROM_QUEUE";
export const SET_CURRENT_TRACK_ID = "SET_CURRENT_TRACK_ID";
export const SET_QUEUE_INDEX = "SET_QUEUE_INDEX";
export const SET_QUEUE_POSITION = "SET_QUEUE_POSITION";

// USER
export const SET_USER = "SET_USER";
export const REMOVE_USER = "REMOVE_USER";
export const SET_PASSWORD_RESET_DATA = "SET_PASSWORD_RESET_DATA";

// PLAYLISTS
export const SET_PLAYLISTS = "SET_PLAYLISTS";
export const CLEAR_PLAYLISTS = "CLEAR_PLAYLISTS";
export const DELETE_PLAYLIST = "DELETE_PLAYLIST";

// PAGE
export const SET_QUEUE_VISIBILITY = "SET_QUEUE_VISIBILITY";
export const SET_CURRENT_MODAL = "SET_CURRENT_MODAL";
export const SET_PAGE_TITLE = "SET_PAGE_TITLE";
export const SET_PAGE_STATUS = "SET_PAGE_STATUS";
export const ADD_PAGE_ERROR = "ADD_PAGE_ERROR";
export const SET_PAGE_ERROR_CODE = "SET_PAGE_ERROR_CODE";
export const CLEAR_PAGE_ERRORS = "CLEAR_PAGE_ERRORS";
export const SET_GENRES_LIST_STATE = "SET_GENRES_LIST_STATE";

// SEARCH
export const SET_SEARCH_RESULTS = "SET_SEARCH_RESULTS";

// PROMOS
export const SET_PROMO = "SET_PROMO";
export const SET_PROMO_STATUS = "SET_PROMO_STATUS";

// STATIC
export const ADD_PAGE = "ADD_PAGE";
